var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsos-call-for-help-header"},[(false)?_c('div',{staticClass:"left"},[_c('h3',{staticStyle:{"margin-bottom":"0px","padding-bottom":"0px"}},[_vm._v(" Call For Help ")])]):_vm._e(),(false)?_c('div',{staticClass:"right"}):_vm._e(),_c('h3',{staticStyle:{"margin-bottom":"0px","padding-bottom":"0px"}},[_vm._v(" Call For Help ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }